import StatamicObject from "./statamicObject"
import Poi from "./poi"
import i18n from "i18next"
import dateFormat from "../utils/dateFormat"

export default class Event extends StatamicObject {
  constructor(data) {
    super(data)
    Object.assign(this, data)

    if (this.startDate === this.endDate) {
      // in this case, we empty the enddate
      this.endDate = null
    }
  }

  getFullDate(date, time, dateType = "start") {
    const fullDate = new Date(date)

    if (time) {
      const [hours, minutes] = time.split(":")
      fullDate.setHours(hours, minutes)
    } else {
      // if there is no startTime, we assume that the event start and ends the
      // whole day
      if (dateType === "end") {
        fullDate.setHours(23, 59)
      } else {
        fullDate.setHours(0, 0)
      }
    }

    if (dateType === "end") {
      this.fullEndDate = fullDate
    } else {
      this.fullStartDate = fullDate
    }

    return fullDate
  }

  getFullStartDate() {
    return this.getFullDate(this.startDate, this.startTime, "start")
  }

  getFullEndDate() {
    // if this.endDate is null, then we use this.startDate
    const date = this.endDate || this.startDate

    return this.getFullDate(date, this.endTime, "end")
  }

  getTimeStatus() {
    const now = new Date()
    const startDate = this.getFullDate(this.startDate, this.startTime)

    if (startDate > now) {
      return "future"
    }

    const endDate = this.getFullEndDate()

    if (endDate < now) {
      return "past"
    } else {
      return "pending"
    }
  }

  getStartDate() {
    let startDate = dateFormat(this.startDate, i18n.language, {
      weekday: "short",
    })

    if (this.startTime) {
      startDate += ` — ${this.startTime}`
    }

    return startDate
  }

  getDateSpan() {
    const days = []
    let startDate = dateFormat(this.startDate, i18n.language, {
      weekday: "long",
    })

    if (!this.endDate) {
      // there is only a start date
      if (this.startTime && !this.endTime) {
        startDate += ` — ${this.startTime}`
      }

      if (this.startTime && this.endTime) {
        startDate += ` — ${this.startTime} - ${this.endTime}`
      }

      days.push(startDate)
    } else {
      // both days have been set
      let endDate = dateFormat(this.endDate, i18n.language, {
        weekday: "long",
      })
      if (this.startTime) {
        startDate += ` — ${this.startTime}`
      }
      if (this.endTime) {
        endDate += ` — ${this.endTime}`
      }

      days.push(startDate)
      days.push(endDate)
    }

    return days
  }

  getPois() {
    return this.poi ? this.poi.map(poi => new Poi(poi)) : []
  }
}
